/**
 * The suggested lists on the protection screen.
 *
 * Clicking one fills the form in below it. Nothing is fetched and nothing is
 * saved: what the button does is save somebody typing a long address by
 * hand, which is the whole of why the addresses are offered rather than
 * written in the documentation.
 */

import { queryAll, query } from "../core/dom";

/** Wire every offered list to the form which adds one. */
export function initFeedOffers(): void {
    const form = query<HTMLFormElement>(".protection-feed-form");
    if (!form) {
        return;
    }

    for (const offer of queryAll<HTMLElement>("[data-feed-offer]")) {
        offer.addEventListener("click", () => {
            const fill = (name: string, value: string | undefined): void => {
                const field = form.elements.namedItem(name);
                if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement) {
                    field.value = value ?? "";
                }
            };

            fill("label", offer.dataset["feedName"]);
            fill("url", offer.dataset["feedUrl"]);
            fill("kind", offer.dataset["feedKind"]);
            fill("action", offer.dataset["feedAction"]);

            const address = form.elements.namedItem("url");
            if (address instanceof HTMLInputElement) {
                address.focus();
            }
        });
    }
}
